// extracted by mini-css-extract-plugin
module.exports = {"animated":"_3PuJzCB"};